let engraveButtonText = '';
function engraveClose() {
	$('#additionalAttributesDrawer').removeClass('active');
	$('.engrave-submit-confirm').removeAttr('formid');
	$('body').removeClass('overflow-hidden');
	$('.custom--overlay').remove();
	if ($(window).innerWidth() <= 768) {
		$('.engrave--accordian').hide();
	}
	engraveButtonText = '';
	document.getElementById('engrave-consent-confirm').disabled = true;
}
let storedEngraveStyle = document.querySelector('.engrave-style1');
let storedEngraveName = document.getElementById('engrave-name-input').value;
let storedEngraveColor = null;
let storedEngraveConsent = false;
function getStoredName() {
	storedEngraveName = document.getElementById('engrave-name-input').value;
}
function getStoredColor() {
	const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
	colorRadioButtons.forEach((button) => {
		if (button.checked) {
			storedEngraveColor = button;
		}
	});
}
function getStoredStyle() {
	const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	styleRadioButtons.forEach((button) => {
		if (button.checked) {
			storedEngraveStyle = button;
		}
	});
}
function getStoredConsent() {
	const engraveConsent = document.getElementById('engrave-consent-input');
	if (engraveConsent.checked) {
		storedEngraveConsent = true;
	} else {
		storedEngraveConsent = false;
	}
}
function validateEngraveInput(dataPosition) {
	const engraveDynamic = document.getElementById('engrave-dynamic');
	$('.engrave--btn--text').on('click', function () {
		engraveButtonText = $(this).text().trim();
		console.log(engraveButtonText);
	});

	if (engraveButtonText == 'Modify my bottle') {
		// Engrave Style
		const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
		styleRadioButtons.forEach((button) => {
			if (button.checked) {
				if (button == storedEngraveStyle) {
					$('#engrave-style-confirm').click();
					const font = storedEngraveStyle.getAttribute('data-font');
					engraveDynamic.style.fontFamily = font;
				} else {
					button.checked = false;
					storedEngraveStyle.checked = true;
					$('#engrave-style-confirm').click();
				}
			}
		});
		// Engrave Name
		let currentEngraveName = document.getElementById('engrave-name-input');
		console.log(currentEngraveName.value, 'haha', currentEngraveName.value === '');
		if (currentEngraveName.value == '') {
			engraveDynamic.innerText = 'Your text here';
			engraveDynamic.style.color = '#121212BF';
		} else {
			document.getElementById('engrave-name-input').value = storedEngraveName;
			engraveDynamic.innerText = storedEngraveName;
		}
		// Engrave Color
		const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
		colorRadioButtons.forEach((button) => {
			if (button.checked) {
				if (button == storedEngraveColor) {
					$('#engrave-color-confirm').click();
					const color = storedEngraveColor.getAttribute('data-color');
					engraveDynamic.style.color = color;
				} else {
					button.checked = false;
					storedEngraveColor.checked = true;
					$('#engrave-color-confirm').click();
				}
			}
		});

		//Engrave Consent

		const engraveConsent = document.getElementById('engrave-consent-input');
		if (engraveConsent.checked) {
			if (storedEngraveConsent) {
				$('#engrave-consent-confirm').click();
			} else {
				engraveConsent.checked = false;
				$('#engrave-consent-confirm').click();
			}
		} else {
			if (storedEngraveConsent) {
				engraveConsent.checked = true;
				$('#engrave-consent-confirm').click();
			} else {
				$('#engrave-consent-confirm').click();
			}
		}
	} else {
		const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
		styleRadioButtons.forEach((button) => {
			button.checked = false;
		});
		document.getElementById('engrave-name-input').value = '';
		const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
		colorRadioButtons.forEach((button) => {
			button.checked = false;
		});
		const engraveDynamic = document.getElementById('engrave-dynamic');
		engraveDynamic.innerText = 'Your text here';
		engraveDynamic.style.color = '#121212BF';
	}
}
// $(document).on('click', '.engrave-close-btn', () => {
// 	engraveClose();
// 	validateEngraveInput();
// 	dynamicEngrave();
// });
function engraveModalClose() {
	$('#myEngraveModal').hide();
}

function engraveInput() {
	$('.accordian--group').each(function () {
		let $accordianGroup = $(this);
		let hasContent = false;
		$accordianGroup.find('input[type="text"]').each(function () {
			if ($(this).val().trim() !== '') {
				hasContent = true;
			}
		});
		$accordianGroup.find('input[type="checkbox"]').each(function () {
			if ($(this).is(':checked')) {
				hasContent = true;
			}
		});
		$accordianGroup.find('input[type="radio"]').each(function () {
			if ($(this).is(':checked')) {
				hasContent = true;
			}
		});
		if (hasContent) {
			$accordianGroup.addClass('has--content');
			$accordianGroup.find('.engrave-confirm').prop('disabled', false);
		} else {
			$accordianGroup.removeClass('has--content');
			$accordianGroup.find('.engrave-confirm').prop('disabled', true);
		}
	});
}

$(document).ready(function () {
	$(
		'.accordian--group input[type="text"], .accordian--group input[type="checkbox"], .accordian--group input[type="radio"]'
	).on('input change', function () {
		engraveInput();
	});
	engraveInput();
});

$(document).on('click', '.accordian--content__container', function () {
	if ($(window).width() > 767) {
		if ($(this).closest('.accordian--group').find('.engrave--input').is(':visible')) {
			$('.engrave--input').hide();
		} else {
			$('.engrave--input').hide();
			$(this).closest('.accordian--group').find('.engrave--input').show();
		}
	}
});

const disableEmptyInputs = () => {
	//Engrave text
	const textInp = document.getElementById('engrave-name-input');
	const textConfirm = document.getElementById('engrave-text-confirm');
	textConfirm.disabled = textInp.value.length ? false : true;
	for (let i = 0; i < textInp.value.length; i++) {
		if (textInp.value[i] == ' ') {
			textConfirm.disabled = true;
		} else {
			textConfirm.disabled = false;
			break;
		}
	}
	//Engrave style
	const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	let isStyleChecked = false;
	styleRadioButtons.forEach((button) => {
		if (button.checked) {
			isStyleChecked = true;
		}
	});
	const styleConfirm = document.getElementById('engrave-style-confirm');
	styleConfirm.disabled = isStyleChecked ? false : true;

	//Engrave color
	const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
	let isColorChecked = false;
	colorRadioButtons.forEach((button) => {
		if (button.checked) {
			isColorChecked = true;
		}
	});
	const colorConfirm = document.getElementById('engrave-color-confirm');
	colorConfirm.disabled = isColorChecked ? false : true;

	//Engrave Consent
	const engraveConsent = document.getElementById('engrave-consent-input');
	const consentConfirm = document.getElementById('engrave-consent-confirm');
	consentConfirm.disabled = !engraveConsent.checked;
};

const checkEmptyFields = () => {
	//Engrave text
	const textInp = document.getElementById('engrave-name-input');
	if (textInp.value.length) {
		let a = '';
		for (let i = 0; i < textInp.value.length; i++) {
			if (textInp.value[i] == ' ') {
				a = a + textInp.value[i];
				if (a.length == textInp.value.length) {
					return { id: '#text-slick', index: 0 };
				}
			} else {
				break;
			}
		}
	} else {
		return { id: '#text-slick', index: 0 };
	}

	//Engrave style
	const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	let isStyleChecked = false;
	styleRadioButtons.forEach((button) => {
		if (button.checked) {
			isStyleChecked = true;
		}
	});
	if (!isStyleChecked) {
		return { id: '#style-slick', index: 1 };
	}

	//Engrave color
	const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
	let isColorChecked = false;
	colorRadioButtons.forEach((button) => {
		if (button.checked) {
			isColorChecked = true;
		}
	});
	if (!isColorChecked) {
		return { id: '#color-slick', index: 2 };
	}

	return null;
};
const addInputFormName = () => {
	const engraveContainer = document.querySelector('.engrave--accordian');
	const engraveInputs = engraveContainer.querySelectorAll('input');
	const productFormId = document.querySelector('.product-form form')?.getAttribute('id');
	engraveInputs.forEach((el) => el.setAttribute('form', productFormId));
};
$(document).on('click', '.accordian--group button', function () {
	// check for empty fields
	const check = checkEmptyFields();
	if ($(window).width() > 767) {
		if ($(this).hasClass('engrave-submit-confirm')) {
			if (check == null) {
				addInputFormName();
				engraveClose();
				$('.engrave--input').hide(1000);
				$('.engrave--input:first').show(1000);
				$('#openDrawerButton').addClass('has--content');
				$('#openDrawerButton .engrave--btn--text').html('Modify my bottle');
			} else {
				$('.engrave--input').hide();
				$(check.id).show();
			}
		} else {
			$('.engrave--input').hide();
			$(this).closest('.accordian--group').next().find('.engrave--input').show();
		}
	} else {
		if ($(this).hasClass('engrave-submit-confirm')) {
			if (check == null) {
				addInputFormName();
				$('.engrave--accordian').slick('slickGoTo', 0);
				engraveClose();
				$('#openDrawerButton').addClass('has--content');
				$('#openDrawerButton .engrave--btn--text').html('Modify my bottle');
				$('#openDrawerButton .engrave--btn--text').addClass('has--content');
				$('.engrave--accordian').slick('unslick');
			} else {
				$('.engrave--accordian').slick('slickGoTo', check.index);
			}
		} else {
			let currentSlide = $(this).closest('.accordian--group').attr('data-slick-index');
			let nextSlide = Number(currentSlide) + 1;
			$('.engrave--accordian').slick('slickGoTo', nextSlide);
		}
	}
});

$('.engrave--input:first').show();

$(document).on('click', '.engrave--clear', function () {
	$('#myEngraveModal').css('display', 'flex');
});
$(document).on('click', '#myEngraveModal #remove-gift-wrap', function () {
	$('.engrave--input input').each(function () {
		$(this).removeAttr('form');
		if ($(this).attr('type') === 'text') {
			$(this).val('');
			storedEngraveName = '';
		} else if ($(this).attr('type') === 'checkbox' || $(this).attr('name') === 'properties[_engravingColor]') {
			$(this).prop('checked', false);
		}
	});
	$('#engrave-dynamic').html('Your text here').removeAttr('style');
	$('#openDrawerButton .engrave--btn--text').html(' Engrave my bottle');
	$('#openDrawerButton').removeClass('has--content');
	engraveModalClose();
});
$(document).on('click', '#myEngraveModal .close, #engrave-drawer-cancel', function () {
	engraveModalClose();
});

let openBtn = $('#openDrawerButton');
function detectClickOutsideDiv(divId, idTwo) {
	document.addEventListener('click', function (event) {
		const clickedElement = event.target;
		const targetDiv = document.getElementById(divId);
		if (
			clickedElement !== targetDiv &&
			!targetDiv.contains(clickedElement) &&
			$(event.target).closest(idTwo).length == 0
		) {
			// Click occurred outside the specified div
			$(`#${divId}`).removeClass('active');
			$('body').removeClass('overflow-hidden');
		}
	});
}

//for both
function openDrawer(dataPostion) {
	$('#additionalAttributesDrawer').addClass('active');
	dataValue = $('#openDrawerButton').data('formid');
	validateEngraveInput(dataPostion);
	// $('.engrave-submit-confirm').attr('data-position', dataPostion);
	$('.engrave-submit-confirm').attr('formid', dataValue);
	$('body').addClass('overflow-hidden');
	$('body').append($('<div class="custom--overlay"></div>'));
	if ($(window).innerWidth() <= 768) {
		$('.engrave--accordian').show();
	}
}

$(document).on('click', '#openDrawerButton, .engrave-cart-wrap', function (e) {
	e.preventDefault();
	let dataPostion = $(this).attr('data-position');
	openDrawer(dataPostion);
	disableEmptyInputs();
	// detectClickOutsideDiv('additionalAttributesDrawer', '#openDrawerButton');
});

//web
$(document).on('click', '#webopenDrawerButton', function (e) {
	e.preventDefault();
	$('#webadditionalAttributesDrawer').addClass('active');
	detectClickOutsideDiv('webadditionalAttributesDrawer', '#webopenDrawerButton');
});

//mobile
$(document).on('click', '#mobileopenDrawerButton', function (e) {
	e.preventDefault();
	$('#mobileadditionalAttributesDrawer').addClass('active');
	detectClickOutsideDiv('mobileadditionalAttributesDrawer', '#mobileopenDrawerButton');
});
// engrave mobile slider
$(document).ready(function () {
	function mobileEngrave() {
		if ($(window).width() <= 767) {
			if (!$('.engrave--accordian').hasClass('slick-initialized')) {
				$('.engrave--accordian').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: false,
					arrows: true,
					infinite: false,
				});
			}
		}
	}
	// $(window).resize(function () {
	//   mobileEngrave();
	// });
	$(document).on('click', '#openDrawerButton, .engrave-cart-wrap', function () {
		mobileEngrave();
	});
});

document.addEventListener('DOMContentLoaded', () => {
	//Text input
	const textInp = document.getElementById('engrave-name-input');
	const textConfirm = document.getElementById('engrave-text-confirm');
	textInp?.addEventListener('input', (e) => {
		if (e.target.value.length) {
			for (let i = 0; i < e.target.value.length; i++) {
				if (e.target.value.length[i] == ' ') {
					textConfirm.setAttribute('disabled', 'true');
				} else {
					textConfirm.removeAttribute('disabled');
					break;
				}
			}
		} else {
			textConfirm.setAttribute('disabled', 'true');
		}
	});

	//Engrave color
	const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
	const colorConfirmButton = document.getElementById('engrave-color-confirm');

	function checkColorRadioButtons() {
		let isChecked = false;
		colorRadioButtons.forEach((button) => {
			if (button.checked) {
				isChecked = true;
			}
		});
		colorConfirmButton.disabled = !isChecked;
		colorConfirmButton.closest('.accordian--group').classList.add('has--content');
	}

	colorRadioButtons.forEach((button) => {
		button.addEventListener('change', checkColorRadioButtons);
	});

	//Engrave style
	const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	const styleConfirmButton = document.getElementById('engrave-style-confirm');

	function checkStyleRadioButtons() {
		let isChecked = false;
		styleRadioButtons.forEach((button) => {
			if (button.checked) {
				isChecked = true;
			}
		});
		if (styleConfirmButton) styleConfirmButton.disabled = !isChecked;
		styleConfirmButton?.closest('.accordian--group').classList.add('has--content');
	}

	styleRadioButtons.forEach((button) => {
		button.addEventListener('change', checkStyleRadioButtons);
	});

	//consent check
	const consentInp = document.getElementById('engrave-consent-input');
	const consentConfirm = document.getElementById('engrave-consent-confirm');
	consentInp?.addEventListener('input', (e) => {
		if (e.target.checked) {
			consentConfirm.removeAttribute('disabled');
		} else {
			consentConfirm.setAttribute('disabled', 'true');
		}
	});
});

const dynamicEngrave = () => {
	const textInp = document.getElementById('engrave-name-input');
	const engraveDynamic = document.getElementById('engrave-dynamic');
	textInp?.addEventListener('input', (e) => {
		engraveDynamic.innerText = e.target.value;
		const styleRadios = document.querySelectorAll('[name="properties[_engravingStyle]"]');
		styleRadios.forEach((radio) => {
			if (radio.checked) {
				const font = radio.getAttribute('data-font');
				engraveDynamic.style.fontFamily = font;
			}
		});
	});

	const styleRadios = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	styleRadios.forEach((radio) => {
		radio.addEventListener('change', function () {
			if (this.checked) {
				const font = this.getAttribute('data-font');
				engraveDynamic.style.fontFamily = font;
			}
		});
	});

	const colorRadios = document.querySelectorAll('[name="properties[_engravingColor]"]');
	colorRadios.forEach((radio) => {
		radio.addEventListener('change', function () {
			if (this.checked) {
				const color = this.getAttribute('data-color');
				engraveDynamic.style.color = color;
			}
		});
	});
};

document.addEventListener('DOMContentLoaded', () => {
	dynamicEngrave();
});

const textConfirmButton = document.getElementById('engrave-text-confirm');
textConfirmButton.addEventListener('click', () => {
	const errMsgAvl = document.getElementById('engrave--err-text--input');
	errMsgAvl ? errMsgAvl.remove() : null;
	getStoredName();
});
const colorConfirmButton = document.getElementById('engrave-color-confirm');
colorConfirmButton.addEventListener('click', () => {
	getStoredColor();
});
const styleConfirmButton = document.getElementById('engrave-style-confirm');
styleConfirmButton.addEventListener('click', () => {
	getStoredStyle();
});
const consentConfirmButton = document.getElementById('engrave-consent-confirm');
consentConfirmButton.addEventListener('click', () => {
	getStoredConsent();
});
$(document).on('click', '.engrave-close-btn', () => {
	engraveClose();
});
